import React from "react";
import { Form, Input, InputNumber, Select } from "antd";
import svg150 from "../../../../assets/svg/svg150.svg";
import svg151 from "../../../../assets/svg/svg151.svg";
import { kplcOptionsData } from "../../../../data";

function AccountForm({ form, handleCancel, handleBuyNow }) {
  const handleSubmit = async () => {
    try {
      await form.validateFields(["accountNumber", "amount", "requestType"]);
      const values = form.getFieldsValue(["accountNumber", "amount", "requestType"]);
      handleBuyNow(values);
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  return (
    <div>
      <div className="text-ink font-lexendS font-[600] text-[1.5rem] leading-[2rem] py-[1.5rem]">Buy KPLC Tokens</div>
      <Form.Item
        label={"Account Number"}
        name="accountNumber"
        rules={[{ required: true, message: "Please enter account number" }]}
        extra={
          <span className="text-body text-[0.75rem] font-[400] leading-[1rem] font-lexendS">
            Enter a valid KPLC account number, then proceed.
          </span>
        }
      >
        <Input prefix="#" placeholder="" className="input" />
      </Form.Item>

      <Form.Item
        label="Request Type"
        name="requestType"
        rules={[{ required: true, message: "Please select request type" }]}
      >
         <Select
          placeholder="Select request type"
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={kplcOptionsData?.map((item) => ({
            value: item?.value,
            label: item?.label,
          }))}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label?.toLocaleLowerCase() ?? "").includes(
              input?.toLocaleLowerCase()
            )
          }
        />
 
      </Form.Item>

      <Form.Item
        label="Amount"
        name="amount"
        rules={[{ required: true, message: "Please enter amount" }]}
        extra={
          <span className="text-body text-[0.75rem] font-[400] leading-[1rem] font-lexendS">
            How much do you want to pay?
          </span>
        }
      >
        <InputNumber
          min={30}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>

      <div className="flex justify-end items-center gap-x-[0.5rem] mt-[1rem]">
        <button
          type="button"
          onClick={handleCancel}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] border border-line bg-white py-[0.5rem] px-[1rem] text-ink text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg150} alt="close" />
          Close
        </button>

        <button
          type="button"
          onClick={handleSubmit}
          className="flex items-center gap-[0.5rem] rounded-[624.9375rem] bg-[#1E191B] py-[0.5rem] px-[1rem] text-white text-[0.875rem] font-[500] leading-[1.25rem] font-lexendS"
        >
          <img src={svg151} alt="buy" />
          Buy Now
        </button>
      </div>
    </div>
  );
}

export default AccountForm;
